module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-fun-calendar"
  }, [_c('div', {
    staticClass: "custom-fun-calendar__container"
  }, [_c('div', {
    staticClass: "custom-fun-calendar__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-fun-calendar__content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), _vm._l((_vm.props.buttons), function(button, i) {
    return _c('a', {
      key: "button - " + i,
      staticClass: "custom-fun-calendar__button",
      attrs: {
        "href": button.href,
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      domProps: {
        "innerHTML": _vm._s(button.label)
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f458a9c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-fun-calendar/custom-fun-calendar.pug
// module id = 618
// module chunks = 1